const valueCheck = (el) => {
  let results = [];
  const types = el.dataset.type.split(',');

  types.forEach(type => {
    let isValid;

    switch (type) {
      case 'string':
        isValid = el.value.match(/.+/) ? true : false;
        break;
      case 'string-kana':
        isValid = el.value.match(/^[ァ-ヶー　\s]+$/) ? true : false;
        break;
      case 'tel':
        isValid = !el.value || el.value.match(/^\d{1,4}-?\d{1,4}-?\d{3,4}$/) ? true : false;
        break;
      case 'number':
        isValid = el.value.match(/^\d+$/) ? true : false;
        break;
      case 'mail':
        isValid = el.value.match(/^.+@.+\..+$/) ? true : false;
        break;
      case 'select':
        isValid = el.value.match(/.+/) ? true : false;
        break;
      case 'select-number':
        isValid = el.value.match(/.+/) ? true : false || !isNaN(parseInt(el.value, 10));
        break;
      case 'post':
        isValid = !el.value || el.value.match(/^\d{1,3}-?\d{1,4}$/) ? true : false;
        break;
      case 'checkbox':
      case 'radio':
        const name = $(el).attr('name');
        const val = $(el).closest('.validate-target').find(`input[name="${name}"]:checked`).val();

        isValid = val ? true : false;
        break;
    }
    results.push(isValid);
  });

  return results.every(value => value);
};

export default valueCheck;
